import { CommandingRunTask } from "./commandingRunTask";
import { File } from "./file";

export class CommandingRun {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  commandingId: string;
  inputTasks?: string;
  renderedInputTasks?: string;
  inputTaskResponses?: string;
  outputTasks?: string;
  renderedOutputTasks?: string;
  outputTaskResponses?: string;
  tasks: CommandingRunTask[];
  assets: File[];
  propelOrgId: string;

  constructor(params: CommandingRunParams) {
    this.id = params.id;
    this.updatedAt = params.updatedAt;
    this.createdAt = params.createdAt;
    this.commandingId = params.commandingId;
    this.inputTasks = params.inputTasks;
    this.renderedInputTasks = params.renderedInputTasks;
    this.inputTaskResponses = params.inputTaskResponses;
    this.outputTasks = params.outputTasks;
    this.renderedOutputTasks = params.renderedOutputTasks;
    this.outputTaskResponses = params.outputTaskResponses;
    this.tasks = params.tasks || [];
    this.assets = params.assets || [];
    this.propelOrgId = params.propelOrgId || '';
  }
}

export interface CommandingRunParams {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  commandingId: string;
  inputTasks?: string;
  renderedInputTasks?: string;
  inputTaskResponses?: string;
  outputTasks?: string;
  renderedOutputTasks?: string;
  outputTaskResponses?: string;
  tasks?: CommandingRunTask[];
  assets?: File[];
  /** The org of the run's commanding. CommandingRunAccess sets it on create from the writer org; callers never choose it. */
  propelOrgId?: string;
}
